import React from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import App from '../src/main-component/App/App';
import reportWebVitals from './reportWebVitals';
import '../node_modules/react-modal-video/scss/modal-video.scss';
import 'bootstrap/dist/css/bootstrap.min.css';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import './css/fontawesome.css';
import './css/themify-icons.css';
import './css/animate.css';
import './sass/style.scss';


// Hydrate when pre-rendered HTML is present (react-snap), otherwise normal render.
//
// /admin, /portal, and /proposal-share are never in reactSnap.include
// (package.json) — they're auth-gated/dynamic routes with no real
// prerendered snapshot. A fresh (non-SPA-navigation) load of one of these
// paths still gets served SOME index.html by the host's SPA fallback —
// typically the homepage's prerendered one — so rootEl.hasChildNodes() is
// true even though its content belongs to a completely different route.
// hydrateRoot then mismatches that content against these routes' actual
// output, throwing React hydration errors (#418/#423) before discarding it
// and re-rendering from scratch — a real, console-visible content flash on
// every direct/refreshed load of the portals. These path prefixes always
// render fresh instead, regardless of what's already in the DOM.
const rootEl = document.getElementById('root');
const neverPrerendered = /^\/(admin|portal|proposal-share)(\/|$)/.test(window.location.pathname);
if (!neverPrerendered && rootEl.hasChildNodes()) {
    hydrateRoot(rootEl, <App />);
} else {
    createRoot(rootEl).render(<App />);
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
